// extracted by mini-css-extract-plugin
export default {"wrapper":"Mr-z","response":"Nr-z","error":"Or-z","disabled":"Pr-z","buttons":"Qr-z","feedbackQuestionSection":"Rr-z","yesNoWrapper":"Sr-z"};